////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, map } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const translationsManager = {
	[ActionsTypes.GET_LIST_TRANSLATIONS]: (state) =>
		update(state, {
			translationsManager: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.GET_LIST_TRANSLATIONS_SUCCESS]: (state, payload) => {
		const paging = {
			totalElements: payload.data.headerContent.contentPagined.totalElements,
			totalPages: payload.data.headerContent.contentPagined.totalPages,
			refLangFlag: payload.data.headerContent.contentPagined.refLangFlag,
			toTranslateLangFlag: payload.data.headerContent.contentPagined.toTranslateLangFlag,
		}
		return update(state, {
			translationsManager: {
				isLoading: {
					$set: false,
				},
				paging: {
					$set: paging,
				},
				items: {
					$set: payload.data.headerContent.contentPagined.content,
				},
				header: {
					$set: payload.data.headerParam.filters,
				},
			},
		})
	},
	[ActionsTypes.GET_LIST_TRANSLATIONS_FAILURE]: (state, payload) =>
		update(state, {
			translationsManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.SET_TRANSLATION]: (state) =>
		update(state, {
			translationsManager: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.SET_TRANSLATION_SUCCESS]: (state, payload) => {
		// Replace prev value by new one
		let actualTranslationList = cloneDeep(state.translationsManager.items)
		actualTranslationList = map(actualTranslationList, (o) => {
			if (o.id === payload.data.idTranslation) {
				o.actualTranslation.value = payload.data.translationText
				// We also need to update value of referential language,
				// if it is the same as the modified language
				if (payload.idLanguage === o.referentialTranslation.idLanguage) {
					o.referentialTranslation.value = payload.data.translationText
				}
			}
			return o
		})
		return update(state, {
			translationsManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
				items: {
					$set: actualTranslationList,
				},
			},
		})
	},
	[ActionsTypes.SET_TRANSLATION_FAILURE]: (state, payload) => {
		return update(state, {
			translationsManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
				update: {
					$set: false,
				},
			},
		})
	},
}

export default translationsManager
